<template>
  <div data-aos="fade-up" data-aos-offset="0" id="caseDetail">
    <v-container
      fluid
      class="titleContent "
      :style="{
        background:
          'linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)),url(' +
          SYS.setImg(photoItem) +
          ') no-repeat center center / cover'
      }"
    >
      <v-row justify="center" align="center" class="text-center verticalCenter">
        <v-col>
          <div class="ct-text-subtitle bold">{{ item.CaseName }}</div>
        </v-col>
      </v-row>
    </v-container>
    <v-breadcrumbs :items="breadItems" divider="/"></v-breadcrumbs>
    <section>
      <v-container class="sect1-content" style="">
        <v-row justify="center" align="center">
          <v-col style="text-align:center">
            <span class="ct-text-subtitle sectTitle2">{{
              item.schoolCounty + item.schoolName
            }}</span>
          </v-col>
          <!-- <v-col>
            <div
              class="ct-text-subtitle2 ct-text-bolder"
              style="text-align:center"
            >
              {{ item.schoolCounty + item.schoolName }}
            </div>
          </v-col> -->
        </v-row>
        <v-row justify="center" align="center">
          <!-- <v-col>
            <div class="sectTitle2 mx-auto" style="text-align:center">
              
            </div>
          </v-col> -->
        </v-row>
        <v-row class="d-flex justify-center align-center mt-12">
          <v-col>
            <div
              class="ct-font-JH"
              style="white-space:pre-wrap"
              v-html="TOOL.replaceUnitToRem(item.CaseDescription)"
            ></div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section>
      <v-container fluid class="pa-0" style="height:inherit">
        <!-- background-color:#F7F3EB; -->
        <v-row class="d-flex justify-center">
          <v-col cols="9">
            <PhotoList :item="item" :topic="item.Title" />
          </v-col>
        </v-row>
        <!-- <v-row class="ma-0 pa-0" style="height:inherit">
          <v-col
            cols="12"
            md="8"
            class="pa-0 caseImage"
            :style="{
              'background-image': 'url(' + SYS.setImg(photoItem) + ')'
            }"
            style="background-color:yellow;height:inherit"
          ></v-col>
          <v-col cols="12" md="4" style="height:inherit">
            <div
              :class="{
                'ma-auto': $vuetify.breakpoint.sm,
                'ma-0': !$vuetify.breakpoint.sm
              }"
              class="d-flex justify-center align-center"
              style="width:150px;display:inline-block"
            >
              <span class="arrow btn" @click="prev()">&emsp;</span>
              <span class="ct-text-subtitle2 ct-text-bolder">{{
                photoList.findIndex(p => p.name == photoItem.name) +
                  1 +
                  "/" +
                  photoList.length
              }}</span>
              <span class="arrow right btn" @click="next()">&emsp;</span>
            </div>
            <div>
              <div class="ct-text-h1 ct-text-bolder ct-font-JH">
                {{ photoList.findIndex(p => p.name == photoItem.name) + 1 }}
              </div>
              <div class="ct-text-subtitle ct-text-bolder ct-font-JH my-3">
                {{ photoItem.desc }}
              </div>
            </div>
          </v-col>
        </v-row> -->
      </v-container>
    </section>
    <section style="min-height:0">
      <v-container>
        <v-row class="my-6">
          <v-col style="text-align:center">
            <span class="ct-text-subtitle sectTitle2">使用樹種</span>
          </v-col>
          <!-- <v-col>
            <treeTitle title="使用樹種" />
          </v-col> -->
        </v-row>
        <v-row class="content justify-center align-center my-6">
          <v-col v-for="(i, idx) in topTenList" :key="idx" md="4" cols="12">
            <BookPick :item="i" />
          </v-col>
          <v-col></v-col>
        </v-row>
        <!-- <cardGroup :items="topTenList" subject="使用樹種"></cardGroup> -->
      </v-container>
    </section>
    <section style="height: calc(100vh - 65px);">
      <div id="casemap"></div>
    </section>
    <!-- <div class="my-6 d-flex justify-center align-center mx-auto">
      <ListBack />
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import L from "leaflet";
//import treeTitle from "@/components/ui/treeTitle.vue";
import Footer from "@/components/layouts/footer.vue";
//import cardGroup from "@/components/book/cardGroup.vue";
import PhotoList from "@/components/ui/detailComponent/PhotoList.vue";
// import ListBack from "@/components/ui/detailComponent/ListBack.vue";
import BookPick from "@/components/book/bookPick.vue";
import { forceScrollToTopMixin } from "@/mixins/scrollToTop.js";

export default {
  name: "CaseDetail",
  mixins: [forceScrollToTopMixin],
  components: {
    //treeTitle,
    Footer,
    //cardGroup,
    PhotoList,
    // ListBack,
    BookPick
  },
  data() {
    return {
      idx: 0,
      photoList: [],
      photoItem: {
        CaseId: 3,
        CasePhotoId: 6,
        PhotoDescription: "464646"
      },
      item: {
        CampusCode: "",
        CaseDescription: "",
        CaseName: "",
        ShowFristPage: "",
        Sno: 0,
        TreeId: "",
        photoList: [],
        schoolName: "",
        schoolCounty: ""
      },
      map: null,
      topTenList: [],
      topTenOriList: [],
      treeList: [],
      breadItems: [
        {
          text: "植樹案例分享",
          disabled: false,
          href: "/Book"
        }
        // {
        //   text: "this.item.schoolCounty + this.item.schoolName",
        //   disabled: true,
        //   href: "breadcrumbs_link_2"
        // }
      ],
      viewBound: null,
      tolerance: 300
    };
  },
  methods: {
    getBookIndex() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Book/GetBookList`,
        params: {
          id: this.item.TreeId
        }
      }).then(resp => {
        this.topTenList = resp.data.data.topTenList;
        this.topTenOriList = resp.data.data.topTenOriList;
        this.treeList = resp.data.data.treeList;
      });
    },
    getCaseDetail() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Case/GetCaseDetail`,
        params: {
          sno: this.$route.query.name
        }
      }).then(resp => {
        this.item = resp.data.data;
        if (
          typeof this.item.photoList !== "undefined" &&
          this.item.photoList.length > 0
        ) {
          this.photoList = this.item.photoList;
          this.photoItem = this.item.photoList[0];
        }
      });
    },
    getMapIndex() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Map/GetMapIndex`
      }).then(resp => {
        this.$store.dispatch("setCity", resp.data.data.CityList);
        this.$store.dispatch("setTown", resp.data.data.TownList);
        this.$store.dispatch("setSchool", resp.data.data.SchoolList);
        this.$store.dispatch("setTreeType", resp.data.data.TreeTypeList);
      });
    },
    getMapDetail() {
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Map/GetMapSearch`,
        params: {
          city: null,
          town: null,
          school: null,
          treeType: null,
          school_id: this.item.CampusCode
        }
      }).then(resp => {
        if (
          typeof resp.data.data.treeBound !== "undefined" &&
          resp.data.data.treeBound != null
        ) {
          let bound = resp.data.data.treeBound;
          this.CHART.setRandomColor(
            this.$store.state.map.treeType,
            "Value",
            "Type"
          );
          this.MAP.map.flyToBounds(
            L.latLngBounds(
              L.latLng(bound.ymax, bound.xmin),
              L.latLng(bound.ymin, bound.xmax)
            )
          );
        }
      });
    },
    drawPoint(dataArr = [], col_name = "") {
      try {
        //let pointArr = [];
        if (this.pointLayerGroup != null) {
          this.MAP.map.removeLayer(this.pointLayerGroup);
        }

        this.pointLayerGroup = this.setPointGroup(dataArr, col_name);
        this.pointLayerGroup.addTo(this.MAP.map);
      } catch (e) {
        console.log(e);
      }
    },
    setPointGroup(dataArr, col_name) {
      let pointLayerGroup = L.markerClusterGroup({
        maxClusterRadius: 80,
        disableClusteringAtZoom: 16,
        spiderfyOnMaxZoom: false
      });

      for (let i = 0; i < dataArr.length; i++) {
        let color = this.CHART.colorSet.find(
          p =>
            (typeof p.text === "string" &&
              p.text.includes(dataArr[i][col_name])) ||
            p.text == dataArr[i][col_name]
        );
        let point = L.circle([dataArr[i].y, dataArr[i].x], {
          radius: 2,
          fill: true,
          fillOpacity: 1,
          fillColor:
            typeof color !== "undefined" ? color.color : "rgba(0,0,0,0)",
          color: typeof color !== "undefined" ? color.color : "rgba(0,0,0,0)",
          data: dataArr[i]
        });
        if (typeof color !== "undefined") {
          dataArr[i].color = color.color;
        }
        pointLayerGroup.addLayer(point);
      }
      return pointLayerGroup;
    },
    getViewBound() {
      let map = this.MAP.map;
      let rb_p = map.latLngToContainerPoint(map.getBounds().getSouthEast());
      let lt_p = map.latLngToContainerPoint(map.getBounds().getNorthWest());
      let n = map.containerPointToLatLng(
        L.point(lt_p.x, lt_p.y - this.tolerance)
      ).lat;
      let w = map.containerPointToLatLng(
        L.point(lt_p.x - this.tolerance, lt_p.y)
      ).lng;
      let s = map.containerPointToLatLng(
        L.point(rb_p.x, rb_p.y + this.tolerance)
      ).lat;
      let e = map.containerPointToLatLng(
        L.point(rb_p.x + this.tolerance, rb_p.y)
      ).lng;
      return L.latLngBounds(L.latLng(s, w), L.latLng(n, e));
    },
    getMapPoint() {
      this.viewBound = this.getViewBound();
      this.localLoading = true;
      return this.axios({
        methods: "get",
        url: `${process.env.VUE_APP_API_URL}api/Map/GetPointGroup`,
        params: {
          n: this.viewBound.getNorth(),
          w: this.viewBound.getWest(),
          s: this.viewBound.getSouth(),
          e: this.viewBound.getEast()
        }
      }).then(resp => {
        if (this.MAP.map.getZoom() >= 14) {
          if (
            resp.data.data.treeList != null &&
            resp.data.data.treeList.length > 0
          ) {
            this.drawPoint(resp.data.data.treeList, "n");
          }
        }
        this.localLoading = false;
      });
    },
    prev() {
      let idx = this.idx;
      idx--;
      if (idx < 0) idx = this.photoList.length - 1;
      this.photoItem = this.photoList[idx];
      this.idx = idx;
      //this.prevA = true;
    },
    next() {
      let idx = this.idx;
      idx++;
      if (idx >= this.photoList.length) idx = 0;
      this.photoItem = this.photoList[idx];
      this.idx = idx;
      //this.prevA = false;
    }
  },
  mounted() {
    this.map = this.MAP.initMap("casemap");
    this.MAP.getCampusBound({
      interactive: false,
      ballon: true,
      bindPopup: true,
      bindTooltip: false,
      preferCanvas: true
    });
    this.MAP.fixedScroll();
    this.map.addLayer(this.MAP.getWMSLayer("PHOTO2"));
    //this.MAP.getCampusBound();
    this.getCaseDetail().then(async () => {
      document.title += "-" + this.item.CaseName;
      await this.getMapIndex();
      this.getMapDetail();
      this.getBookIndex();
    });

    // disable map dblclick zoom
    this.MAP.map.doubleClickZoom.disable();
    this.MAP.map.on("zoomend", () => {
      let zoom = this.MAP.map.getZoom();
      let bound = this.getViewBound();
      if (
        zoom >= 14 &&
        (this.viewBound == null || !this.viewBound.contains(bound))
      ) {
        this.getMapPoint();
      }
    });
    this.MAP.zoomToTaiwan();
    this.MAP.map.on("dragend", () => {
      let zoom = this.MAP.map.getZoom();
      let center = this.MAP.map.getCenter();
      if (
        this.viewBound != null &&
        this.MAP.map
          .latLngToContainerPoint(center)
          .distanceTo(
            this.MAP.map.latLngToContainerPoint(this.viewBound.getCenter())
          ) >
          this.tolerance * 3 &&
        zoom >= 14
      ) {
        this.getMapPoint();
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.caseImage {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
}
#caseDetail {
  background-color: #e5e5e5;
}
section {
  position: relative;
  display: block;
  //min-height: calc(100vh - 65px);
}
#casemap {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background-color: #f7f3eb;
  z-index: 0;
  line-height: 0;
  tab-size: 0;
  margin: 0;
  width: 100%;
  height: inherit;
}
.sect1-title {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url("~@/assets/images/case/sect1/bg-title.png");
}
.sect1-content {
  position: relative;
  @include pc {
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: 0px;
    //   left: -107px;
    //   width: 127px;
    //   height: 236px;
    //   background-size: 100% 100%;
    //   background-repeat: no-repeat;
    //   background-position: 50% 50%;
    //   background-image: url("~@/assets/images/case/sect1/img-people.png");
    // }
    // &::after {
    //   content: "";
    //   position: absolute;
    //   bottom: 0px;
    //   right: -99px;
    //   width: 119px;
    //   height: 138px;
    //   background-size: 100% 100%;
    //   background-repeat: no-repeat;
    //   background-position: 50% 50%;
    //   background-image: url("~@/assets/images/case/sect1/img-children.png");
    // }
  }
}
.titleContent {
  height: 450px;
  color: white;
}
</style>
